/**
 * Signup and login URLs can carry credentials or PII in their query string
 * (login 2FA `token`, the funnels' `email`/`first`/`last` prefills), and step
 * navigation preserves query params — strip them before reporting. The
 * post-registration `Signup: Completed` fires from a `/signup/<step>` URL that
 * still holds the prefills, so it needs this too.
 */
const SENSITIVE_QUERY_PARAMS = ['token', 'email', 'first', 'last', 'code'];

/**
 * `url`/`search` with the sensitive params removed, to spread over the standard
 * meta block (`getAnalyticsMetaProperties`) which reads `window.location` raw.
 */
export function sanitizedLocation() {
  const url = new URL(window.location.href);
  for (const param of SENSITIVE_QUERY_PARAMS) {
    url.searchParams.delete(param);
  }
  return { url: url.toString(), search: url.search };
}
